import React from 'react';
import { 
  ChevronLeft, 
  ChevronRight, 
  LayoutGrid, 
  List, 
  Plus,
  Calendar as CalendarIcon
} from 'lucide-react';

const CalendarHeader = ({ 
  currentDate, 
  onPrevMonth, 
  onNextMonth, 
  onToday, 
  viewMode, 
  setViewMode, 
  onAddEvent 
}) => {
  const monthYear = currentDate.toLocaleString('default', { month: 'long', year: 'numeric' });

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 bg-white p-3 rounded shadow-sm border border-gray-100 mb-3">
      {/* Title & Nav */}
      <div className="flex items-center space-x-3">
        <div className="p-1.5 rounded" style={{ backgroundColor: 'color-mix(in srgb, var(--primary-color, #4f46e5) 10%, white)' }}>
          <CalendarIcon className="h-4 w-4" style={{ color: 'var(--primary-color, #4f46e5)' }} />
        </div>
        <div>
          <h2 className="text-sm font-bold text-gray-900">{monthYear}</h2>
          <p className="text-xs text-gray-500">Manage your academic schedule</p>
        </div>
      </div>

      {/* Controls */}
      <div className="flex flex-wrap items-center gap-2">
        {/* Navigation */}
        <div className="flex items-center bg-gray-50 rounded p-0.5 border border-gray-200">
          <button
            onClick={onPrevMonth}
            className="p-1 hover:bg-white hover:shadow-sm rounded transition-all text-gray-600"
            title="Previous Month"
          >
            <ChevronLeft className="h-3.5 w-3.5" />
          </button>
          <button
            onClick={onToday}
            className="px-2 py-0.5 text-xs font-medium text-gray-700 transition-colors"
            style={{ color: 'var(--primary-color, #4f46e5)' }}
            onMouseOver={(e) => e.currentTarget.style.color = 'color-mix(in srgb, var(--primary-color, #4f46e5) 80%, black)'}
            onMouseOut={(e) => e.currentTarget.style.color = 'var(--primary-color, #4f46e5)'}
          >
            Today
          </button>
          <button
            onClick={onNextMonth}
            className="p-1 hover:bg-white hover:shadow-sm rounded transition-all text-gray-600"
            title="Next Month"
          >
            <ChevronRight className="h-3.5 w-3.5" />
          </button>
        </div>

        {/* View Toggle */}
        <div className="flex items-center bg-gray-50 rounded p-0.5 border border-gray-200">
          <button
            onClick={() => setViewMode('grid')}
            className={`p-1 rounded-sm transition-all flex items-center space-x-1 ${
              viewMode === 'grid' 
                ? 'bg-white shadow-sm' 
                : 'text-gray-500 hover:text-gray-700'
            }`}
            style={viewMode === 'grid' ? { color: 'var(--primary-color, #4f46e5)' } : {}}
            title="Grid View"
          >
            <LayoutGrid className="h-3.5 w-3.5" />
            <span className="text-[10px] font-medium hidden sm:inline">Grid</span>
          </button>
          <button
            onClick={() => setViewMode('list')}
            className={`p-1 rounded-sm transition-all flex items-center space-x-1 ${
              viewMode === 'list' 
                ? 'bg-white shadow-sm' 
                : 'text-gray-500 hover:text-gray-700'
            }`}
            style={viewMode === 'list' ? { color: 'var(--primary-color, #4f46e5)' } : {}}
            title="List View"
          >
            <List className="h-3.5 w-3.5" />
            <span className="text-[10px] font-medium hidden sm:inline">List</span>
          </button>
        </div>

        {/* Add Button */}
        <button
          onClick={onAddEvent}
          className="flex items-center space-x-1.5 px-3 py-1.5 text-white rounded transition-colors shadow-sm text-xs btn-primary"
        >
          <Plus className="h-3.5 w-3.5" />
          <span className="font-medium">Add Event</span>
        </button>
      </div>
    </div>
  );
};

export default CalendarHeader;
